export default "__VITE_ASSET__DmpIHySS__"